import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsStringLiteral, useQueryStates } from 'nuqs';

const CODE_OPTIONS = [...Object.values(QuestionCreationWorkflowStepCodeObject), 'ALL'] as const;
type QuestionCreationCodeOptions = (typeof CODE_OPTIONS)[number];

export function useQuestionCreationTaskListSearchParams() {
  const [{ code, page, pageSize, sort }, setQuestionCreationTaskListSearchParams] = useQueryStates({
    code: parseAsStringLiteral(CODE_OPTIONS).withDefault('ALL'),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sort: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
  });

  const changePageNumber = (pageInput: number) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page: pageInput,
      pageSize,
      sort,
    });
  };

  const changePageSize = (pageSizeInput: number) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page: 0,
      pageSize: pageSizeInput,
      sort,
    });
  };

  const changeCode = (codeInput: QuestionCreationCodeOptions) => {
    setQuestionCreationTaskListSearchParams({
      code: codeInput,
      page: 0,
      pageSize,
      sort,
    });
  };

  const changeSortDirection = (sortDirection: (typeof dataGridSortDirection)[number]) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page,
      pageSize,
      sort: sortDirection,
    });
  };

  const getStatusFiltersByCode = (code: QuestionCreationCodeOptions) => {
    switch (code) {
      case QuestionCreationWorkflowStepCodeObject.QuestionCreationTodo: {
        return [QuestionCreationWorkflowStepCodeObject.QuestionCreationTodo];
      }
      case QuestionCreationWorkflowStepCodeObject.QuestionCreationDone:
      case QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress: {
        return [code];
      }
    }

    return null;
  };

  return [
    {
      code,
      page,
      pageSize,
      sort,
    },
    {
      changeCode,
      changePageNumber,
      changePageSize,
      changeSortDirection,
      getStatusFiltersByCode,
    },
  ] as const;
}
